module.exports = __webpack_public_path__ + "img/FilSensorRed.106a86dd.svg";